module.exports = __webpack_public_path__ + "img/apartment_dialog_icon04.38de2835.png";